module.exports = __webpack_public_path__ + "static/Casual-5a1764b909ca2aa8ba7401bb099b8860.png";